import {
  ReferralAdminListResponse,
  ReferralAnalytics,
  ReferralCodeInfo,
  ReferralDetailItem,
  ReferralFilters,
  ReferralSettings,
  ReferralStatsResponse,
  UpdateReferralSettingsRequest,
} from "../types/referral";
import { ApiResponse } from "../types/common";

import apiClient from "./apiClient";

export const getMyReferralCode = async (): Promise<
  ApiResponse<ReferralCodeInfo>
> => {
  const response = await apiClient.get("/referrals/my-code");
  return response.data;
};

export const getMyReferralStats = async (): Promise<
  ApiResponse<ReferralStatsResponse>
> => {
  const response = await apiClient.get("/referrals/my-stats");
  return response.data;
};

export const validateReferralCode = async (
  code: string,
): Promise<ApiResponse<boolean>> => {
  const response = await apiClient.get(
    `/referrals/validate?code=${encodeURIComponent(code)}`,
  );
  return response.data;
};

export const getReferralSettings = async (): Promise<
  ApiResponse<ReferralSettings>
> => {
  const response = await apiClient.get("/admin/referrals/settings");
  return response.data;
};

export const updateReferralSettings = async (
  data: UpdateReferralSettingsRequest,
): Promise<ApiResponse<ReferralSettings>> => {
  const response = await apiClient.put("/admin/referrals/settings", data);
  return response.data;
};

export const getReferrals = async (
  filters: ReferralFilters,
): Promise<ApiResponse<ReferralAdminListResponse>> => {
  const params = new URLSearchParams();
  if (filters.status !== undefined)
    params.append("status", String(filters.status));
  if (filters.referrerEmail)
    params.append("referrerEmail", filters.referrerEmail);
  if (filters.refereeEmail)
    params.append("refereeEmail", filters.refereeEmail);
  if (filters.fromDate) params.append("fromDate", filters.fromDate);
  if (filters.toDate) params.append("toDate", filters.toDate);
  if (filters.page) params.append("page", String(filters.page));
  if (filters.pageSize) params.append("pageSize", String(filters.pageSize));

  const response = await apiClient.get(
    `/admin/referrals?${params.toString()}`,
  );
  return response.data;
};

export const getReferralDetail = async (
  id: string,
): Promise<ApiResponse<ReferralDetailItem>> => {
  const response = await apiClient.get(`/admin/referrals/${id}`);
  return response.data;
};

export const cancelReferral = async (
  id: string,
): Promise<ApiResponse<boolean>> => {
  const response = await apiClient.put(`/admin/referrals/${id}/cancel`);
  return response.data;
};

export const getReferralAnalytics = async (): Promise<
  ApiResponse<ReferralAnalytics>
> => {
  const response = await apiClient.get("/admin/referrals/analytics");
  return response.data;
};
